import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import on from 'dojo/on';
import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import template from './Edit.html?raw';
import docu from './EditDocumentation.html?raw';
import FloatingContainer from '../Floating/FloatingContainer';
import PlaintextEditContainer from './PlaintextEditContainer/PlaintextEditContainer';
import GenericDialog from '../GenericDialog/GenericDialog';
import { StringHelpers, AccessibilityLabelsHelper } from "../../../more/Helpers";
//import DataItems = require("DataItems");



const enum EditInputType {
    text = "text",
    password = "password",
    email = "email",
    tel = "tel",
    html = "html"
    //date = "date",
    //time = "time"
}
class Edit extends compose(_LabelInputBase) {
    templateString: any = template;

    inputNode: HTMLInputElement;
    protected inputContainer: HTMLDivElement;
    protected inputNodeContainer: HTMLElement;
    //errorMsgNode: HTMLSpanElement;
    validationMsgNodeContainer = "errorMsgNode";


    protected inputType: string;
    pattern: string;
    title: string;
    maxLength: number = 524288; // default of 512KB
    minLength: number = 524288; // default of 512KB
    isReadonly: boolean = false;
    isMultiline: boolean = false;
    rows: number = 4; //default value
    isResizeable: boolean | "vertical" | "horizontal" | "both" = false;
    isHtmlEdit: boolean = false;

    protected highlightOnEmptyValue: boolean = false;
    protected _manualHighlightOverride: boolean = false;

    multiLineEditClasses: string = "border w3-block";
    singleLineEditClasses: string = "w3-input border";

    existingInputPropertyNames: Array<string> = ["inputType", "pattern", "title", "maxLength", "isReadonly", "isResizeable"];
    // Methods

    focus() {
        this.inputNode.focus();
    }

    protected swapInputs(bMultiline: boolean): void {

        let inputNode: HTMLTextAreaElement | HTMLInputElement;

        // eventhandlers raushoeln
        let eventHandlers = {};

        if (this.inputNode) {
            this.UiModder.domAttr.get(this.inputNode, "data-dojo-attach-event")?.split(",").forEach(
                kvPair => { eventHandlers[kvPair.slice(0, kvPair.indexOf(":"))] = kvPair.slice(kvPair.indexOf(":") + 1) }
            )
        } else {
            eventHandlers = {
                change: this._onChange_InputNode,
                keyUp: this._onkeyUp_inputNode,
                blur: this._onBlur,
                focus: this._onFocus
            };
        }

        if (this.isMultiline) {
            // FIX: bei Textarea funktioniert keyUp nicht (case sensitiv?!)
            eventHandlers["keyup"] = this._onkeyUp_inputNode;
        }

        // ersatz vorbereiten
        if (bMultiline) {
            inputNode = <HTMLTextAreaElement>this.UiModder.domConstruct.create("textarea", {
                className: this.multiLineEditClasses,
                autocomplete: "off",
                rows: this.rows
            });
            // die normalen blur-Eventhooks funktinieren bei Textarea nicht!!
            inputNode.onblur = lang.hitch(this, this._onBlur);
            inputNode.onfocus = lang.hitch(this, this._onFocus);
        } else {
            inputNode = <HTMLInputElement>this.UiModder.domConstruct.create("input", {
                className: this.singleLineEditClasses,
                autocomplete: "off"
            });
        }

         // eventhandlers anhängen
        for (let entry of Object["entries"](eventHandlers)) {
            on(inputNode, entry[0], lang.hitch(this, entry[1] as Function));
        }

        this.inputNode = <HTMLInputElement>inputNode;

        for (let inputProperty of this.existingInputPropertyNames) {
            this.set(inputProperty, this[inputProperty]);
        }

        this.inputNodeContainer.innerHTML = null;
        this.UiModder.domConstruct.place(this.inputNode, this.inputNodeContainer);

        this.setInputValue();

        this.setReadonly(this.isReadonly);
    }


    protected getStringValue(): string {
        return this._value;
    }


    protected setInputValue(): void {
        if (!this.isHtmlEdit) {
            this.inputNode.value = this._value ? this._value : "";
        } else {
            this.inputNode.innerHTML = this._value ? this._value : "";
        }
    }

    setTitle(title: string): void {
        this.title = title;
        this.UiModder.domAttr.set(this.inputNode, "title", title);
        this.UiModder.domAttr.set(this.inputNode, "name", title);
    }

    getTitle(): string {
        return this.title;
    }

    setInputPattern(pattern: string): void {
        this.pattern = pattern;
        this.UiModder.domAttr.set(this.inputNode, "pattern", pattern);
    }
    setInputName(name: string) {
        this.UiModder.domAttr.set(this.inputNode, "name", name);
    }
    setInputType(type: "text" | "number" | "date" | "time" | "color" | "email" | "month" | "datetime-local" | "tel" | "url" |  "week" | "password" | "search" ): void {
        this.inputType = type;
        this.UiModder.domAttr.set(this.inputNode, "type", type);
    }

    getInputType(): string {
        return this.inputType;
    }

    protected _onkeyUp_inputNode(evt: KeyboardEvent): void {
        //this.emit("keyUp")
        //console.debug(this.id + " keyUp", evt, this.inputNode);
        if (this.isReadonly) return;

        if (evt.key == "Enter") {
            if (!this.isMultiline) {
                //this.inputNode.blur(); // komplett rausspringen und das Blur auslösen
                this._onBlur(evt); // oder nur so tun als obs ein Blur wär (Cursort bleibt im Feld)
                this.emit("enterKey");
                return;
            }
        }

        if (evt.key == "Escape") {
            this.inputNode.blur();
        }

        this._onChange_InputNode();

        this.emit("keyUp", evt);
    }

    // Label



    protected setPlaceholderValue(): void {
        this.inputNode.placeholder = this.placeholder;
    }


    setValue(newValue: any, suppressChangeEvent: boolean = false): void {
        //Steuerzeichen ersetzen, da PIT nur ein \n nicht reicht
        if (this.isMultiline && typeof (newValue) == "string") {
            let cleanValue: string = newValue;
            cleanValue = cleanValue.replaceAll("\n", "\r\n");
            cleanValue = cleanValue.replaceAll("\r\r\n", "\r\n");
            newValue = cleanValue;
        }

        let actuallyChanged = this._value != newValue;

        this._value = newValue;
        if (actuallyChanged) {
            this.setInputValue();

            if (!suppressChangeEvent) {
                this.__delayValueChangeEmit();
            }
        }

        this.validateInput();
    }


    protected customValidation(): boolean {
        let data = this._value;
        let result: boolean = false;

        if (this.pattern && typeof(data) == "string") {
            let testValue = new RegExp(this.pattern);
            result = testValue.test(data);
        } else {
            result = true;
        }

        if (this.isMandatory && (data == undefined || data == "" || data == null)) {

            //this.validationErrorMsgText = window.translations['Generic__mandatory'];
            result = false;

        }

        return result;
    }

    // Event
    protected _onChange_InputNode(): void {
        if (typeof this.inputNode?.value == "string") {
            this.setValue(this.inputNode.value);
        }
    }

    // Doku
    getDocumentationContent(): string {
        return docu;
    }

    // Dojo
    protected _setPatternAttr(pattern:string): void {
        this.setInputPattern(pattern);
    }

    protected _setTitleAttr(title: string) {
        this.setTitle(title);
    }

    protected _getTitleAttr(): string {
        return this.getTitle();
    }

    private _setInputTypeAttr(type:string): void {
        this.setInputType(type as any);
    }

    private _setTypeAttr(type: string): void {
        this._setInputTypeAttr(type);
    }

    getInputTypeAttr(): string {
        return this.getInputType();
    }

    private _setMaxLengthAttr(maxLength: number): void {
        this.setMaxLength(maxLength);
    }
    setMaxLength(maxLength: number): void {
        this.maxLength = maxLength;
        if (this.inputNode) {
            if (this.maxLength > 0) this.UiModder.domAttr.set(this.inputNode, "maxlength", this.maxLength);
            else this.UiModder.domAttr.remove(this.inputNode, "maxlength");
        }
    }
    setMinLength(minLength: number): void {
        this.minLength = minLength;
        if (this.inputNode) {
            if (this.minLength > 0) this.UiModder.domAttr.set(this.inputNode, "minlength", this.minLength);
            else this.UiModder.domAttr.remove(this.inputNode, "minlength");
        }
    }

    protected _setReadonlyStyle(): void {
        if (this.inputNode) {
            this.UiModder.domAttr.set(this.inputNode, "disabled", this.isReadonly);
        }

        this.disableNode(this.inputContainer, this.isReadonly);

        if (this.labelNode) {
            //this.UiModder.domClass.toggle(this.labelNode, "w3-disabled", this.isReadonly);
        }
    }


    private _setIsHtmlEditAttr(bool: boolean): void {
        this.setIsHtmlEdit(bool);
    }

    setIsHtmlEdit(bool: boolean): void {
        this.isHtmlEdit = bool;

        if (this.isHtmlEdit) {
            //Create html input node
            this.UiModder.domClass.add(this.inputContainer, "border");

            var editContainer = this.UiModder.domConstruct.create("div");
            this.UiModder.domClass.add(editContainer, "html-edit-container flex_row nowrap gap_05 paddingSmall");

            var newInputNode = this.UiModder.domConstruct.create("div");
            this.UiModder.domClass.add(newInputNode, "html-input-node width_100 hoverDark");
            this.setValue(this._value ? this._value : "", true);


            var buttonContainer = this.UiModder.domConstruct.create("div");
            this.UiModder.domClass.add(buttonContainer, "flex_col justify_center align_self_start");

            var plaintextEditButton = this.UiModder.domConstruct.create("button");
            this.UiModder.domClass.add(plaintextEditButton, "mds-button-base secondaryBG round hoverBright");

            var editIcon = this.UiModder.domConstruct.create("i");
            this.UiModder.domClass.add(editIcon, "fas fa-edit");

            this.UiModder.domConstruct.place(editIcon, plaintextEditButton);
            this.UiModder.domConstruct.place(plaintextEditButton, buttonContainer);


            //Remove old input node
            this.inputNode = newInputNode as any;
            this.inputNodeContainer.innerHTML = null;

            //Place new input node
            this.UiModder.domConstruct.place(newInputNode, editContainer);
            this.UiModder.domConstruct.place(buttonContainer, editContainer);
            this.UiModder.domConstruct.place(editContainer, this.inputNodeContainer);

            //Add button EventListener
            plaintextEditButton.addEventListener("click", lang.hitch(this, this._onPlaintextButtonClick));
            newInputNode.addEventListener("click", lang.hitch(this, this._onPlaintextButtonClick));
        }
    }


    private _onPlaintextButtonClick(e: MouseEvent): void {
        var dlg = new GenericDialog();

        var editContainer = new PlaintextEditContainer();


        editContainer.setValue(this.getStringValue(), true);

        dlg.show(editContainer, this.translate("HTML_Editor_Heading"), null, null, "okcancel", lang.hitch(this, this._onDlgCallback, editContainer));
    }

    private _onDlgCallback(editContainer: MdsLax<InstanceType<typeof PlaintextEditContainer>>, response: number) {
        if (response === 1) {
            this.setValue(editContainer.getValue());
        }
        if (editContainer.htmlEditor) {
            editContainer.htmlEditor.close();
        }
    }

    private _onClickFloatingOk(floatingContainer: MdsLax<InstanceType<typeof FloatingContainer>>, value: string, e: Event): void {
        floatingContainer.close();
    }

    private _onClickFloatingCancel(floatingContainer: MdsLax<InstanceType<typeof FloatingContainer>>, e: Event): void {
        floatingContainer.close();
    }

    private _setMultilineAttr(bool: boolean): void {
        this.setIsMultiline(bool);
    }
    private _setIsMultilineAttr(bool: boolean): void {
        this.setIsMultiline(bool);
    }
    setIsMultiline(bool: boolean, rows?: number): void {
        if (this.isMultiline == bool) return;

        if (rows) this.rows = rows;

        this.isMultiline = bool;
        this.swapInputs(this.isMultiline);
        this.setRows(this.rows);
        this.setIsResizeable(this.isResizeable);

        this.setMandatory(this.isMandatory);
    }

    private _setRowsAttr(rows: number): void {
        this.setRows(rows);
    }
    setRows(rows: number): void {
        this.rows = rows;
        if(this.isMultiline) this.UiModder.domAttr.set(this.inputNode, "rows", this.rows);
    }

    private _setIsResizeableAttr(bool: boolean): void {
        this.setIsResizeable(bool);
    }

    setIsResizeable(mode: boolean | "vertical" | "horizontal" | "both"): void {
        this.isResizeable = mode;
        if (this.isMultiline) {
            switch (this.isResizeable) {

                case "vertical":
                case "horizontal":
                    this.UiModder.domStyle.set(this.inputNode, "resize", this.isResizeable);
                    break;

                case true:
                case "both":
                    this.UiModder.domStyle.set(this.inputNode, "resize", "both");
                    break;

                case false:
                default:
                    this.UiModder.domStyle.set(this.inputNode, "resize", "none");
                    break;
            }
            this.UiModder.domStyle.set(this.inputNode, "resize", this.isResizeable === true ? "both" : "none");
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


        let value = this.UiModder.domAttr.get(this.domNode, "name");
        if (value) {
            this.UiModder.domAttr.set(this.domNode, "name", value);
            this.domNode.setAttribute("auto-complete", value);
        }
        else this.UiModder.domAttr.set(this.inputNode, "name", StringHelpers.randomID());;

        let title = this.UiModder.domAttr.get(this.domNode, "title");
        if (title) this.setTitle(title);

        AccessibilityLabelsHelper.LabelForInputBind(this.id, this.inputNode, "editInput", this.labelNode);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(Edit);
